const html = document.documentElement
const { body } = document

const scroll = {
  y: 0,
  x: 0,
}

export { html, body, scroll }
